module.exports = __webpack_public_path__ + "static/img/park1 (1).1a2b3523.jpg";